import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_MedicationEmerContactInfo = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_MedicationEmerContactInfo' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Medication/Emergency Contact Information</h3></p>

                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Name</span>
                            <input type='text' name='txtName' id='txtName' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>ID Number</span>
                            <input type='text' name='txtRelationshipNumber' id='txtRelationshipNumber' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Name/Credentials of Staff Initially Completing the form:</span>
                            <input type='text' name='txtCredentials' id='txtCredentials' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Date Initially Completed:</span>
                            <input type='date' name='txtRelationshiDate' id='txtRelationshiDate' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>CURRENT MEDICATIONS</h3></p>

                <p className='w-750'>
                    <span className='eleHeader'>List ALL known and/or reported medications the individual is currently taking regardless of type or purpose to include over-the-counter (OTC) medications </span><span className='small'>(use additional pages, if needed):</span>
                    <textarea id='txtMedications' name='txtMedications' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Date Initiated</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Name of Medication</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Prescribed by</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Dosage/Frequency</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date Terminated/Charged</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated1' id='txtDateInitiated1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication1' id='txtPulseMedication1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed1' id='txtPrescribed1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage1' id='txtDosage1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated1' id='txtTerminated1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated2' id='txtDateInitiated2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication2' id='txtPulseMedication2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed2' id='txtPrescribed2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage2' id='txtDosage2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated2' id='txtTerminated2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated3' id='txtDateInitiated3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication3' id='txtPulseMedication3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed3' id='txtPrescribed3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage3' id='txtDosage3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated3' id='txtTerminated3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated4' id='txtDateInitiated4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication4' id='txtPulseMedication4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed4' id='txtPrescribed4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage4' id='txtDosage4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated4' id='txtTerminated4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated5' id='txtDateInitiated5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication5' id='txtPulseMedication5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed5' id='txtPrescribed5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage5' id='txtDosage5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated5' id='txtTerminated5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated6' id='txtDateInitiated6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication6' id='txtPulseMedication6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed6' id='txtPrescribed6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage6' id='txtDosage6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated6' id='txtTerminated6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated7' id='txtDateInitiated7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication7' id='txtPulseMedication7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed7' id='txtPrescribed7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage7' id='txtDosage7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated7' id='txtTerminated7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated8' id='txtDateInitiated8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication8' id='txtPulseMedication8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed8' id='txtPrescribed8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage8' id='txtDosage8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated8' id='txtTerminated8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated9' id='txtDateInitiated9' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication9' id='txtPulseMedication9' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed9' id='txtPrescribed9' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage9' id='txtDosage9' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated9' id='txtTerminated9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated10' id='txtDateInitiated10' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication10' id='txtPulseMedication10' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed10' id='txtPrescribed10' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage10' id='txtDosage10' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated10' id='txtTerminated10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated11' id='txtDateInitiated11' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication11' id='txtPulseMedication11' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed11' id='txtPrescribed11' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage11' id='txtDosage11' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated11' id='txtTerminated11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated12' id='txtDateInitiated12' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication12' id='txtPulseMedication12' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed12' id='txtPrescribed12' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage12' id='txtDosage12' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated12' id='txtTerminated12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated13' id='txtDateInitiated13' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication13' id='txtPulseMedication13' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed13' id='txtPrescribed13' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage13' id='txtDosage13' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated13' id='txtTerminated13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated14' id='txtDateInitiated14' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication14' id='txtPulseMedication14' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed14' id='txtPrescribed14' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage14' id='txtDosage14' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated14' id='txtTerminated14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated15' id='txtDateInitiated15' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication15' id='txtPulseMedication15' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed15' id='txtPrescribed15' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage15' id='txtDosage15' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated15' id='txtTerminated15' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated16' id='txtDateInitiated16' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication16' id='txtPulseMedication16' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed16' id='txtPrescribed16' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage16' id='txtDosage16' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated16' id='txtTerminated16' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated17' id='txtDateInitiated17' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication17' id='txtPulseMedication17' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed17' id='txtPrescribed17' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage17' id='txtDosage17' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated17' id='txtTerminated17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated18' id='txtDateInitiated18' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication18' id='txtPulseMedication18' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed18' id='txtPrescribed18' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage18' id='txtDosage18' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated18' id='txtTerminated18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated19' id='txtDateInitiated19' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication19' id='txtPulseMedication19' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed19' id='txtPrescribed19' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage19' id='txtDosage19' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated19' id='txtTerminated19' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated20' id='txtDateInitiated20' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication20' id='txtPulseMedication20' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed20' id='txtPrescribed20' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage20' id='txtDosage20' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated20' id='txtTerminated20' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated21' id='txtDateInitiated21' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication21' id='txtPulseMedication21' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed21' id='txtPrescribed21' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage21' id='txtDosage21' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated21' id='txtTerminated21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' name='txtDateInitiated22' id='txtDateInitiated22' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPulseMedication22' id='txtPulseMedication22' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtPrescribed22' id='txtPrescribed22' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtDosage22' id='txtDosage22' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' name='txtTerminated22' id='txtTerminated22' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>PREVIOUS MEDICATIONS</h3></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medication</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Direction</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Comments</span><span className='small'>(to include adverse reactions if applicable)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtVitalsMedication' id='txtVitalsMedication' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtDirection' id='txtDirection' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtComments' id='txtComments' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtVitalsMedication1' id='txtVitalsMedication1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtDirection1' id='txtDirection1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtComments1' id='txtComments1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtVitalsMedication2' id='txtVitalsMedication2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtDirection2' id='txtDirection2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtComments2' id='txtComments2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtVitalsMedication3' id='txtVitalsMedication3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtDirection3' id='txtDirection3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtComments3' id='txtComments3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtVitalsMedication4' id='txtVitalsMedication4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtDirection4' id='txtDirection4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtComments4' id='txtComments4' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Special Dietary Needs </span><span className='small'>(if applicable):</span>
                    <textarea id='txtSpecial' name='txtSpecial' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Emergency Information:</span>
                    <textarea id='txtSpecial1' name='txtSpecial1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>In case of emergency (when parent/legal representative cannot be reached) contact:</span>
                    <textarea id='txtSpecial2' name='txtSpecial2' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number (primary):</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number (secondary):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtVitalsMedicationName1' id='txtVitalsMedicationName1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtPhoneNumberP1' id='txtPhoneNumberP1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtPhoneNumberS1' id='txtPhoneNumberS1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Address:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Primary Doctor:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Doctor's Phone:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtVitalsMedicationName2' id='txtVitalsMedicationName2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtPhoneNumberP2' id='txtPhoneNumberP2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtPhoneNumberS2' id='txtPhoneNumberS2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Doctor's Address:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Hospital Preference:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Insurance Carrier(s):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtVitalsMedicationName3' id='txtVitalsMedicationName3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtPhoneNumberP3' id='txtPhoneNumberP3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtPhoneNumberS3' id='txtPhoneNumberS3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Policy Number(s):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtVitalsMedicationName4' id='txtVitalsMedicationName4' className='add-only' />
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











